<template>
    <div class="file-input-container">
        <div class="bg-success text-center mb-8 rounded p-8" v-if="isPdf">
            {{ uploadedFile.file_url }} successfully uploaded.
        </div>

        <label :for="id" :id="id + '-upload-button'" class="py-2 px-8 rounded-full text-white hover:opacity-70 transition border border-light-blue cursor-pointer" :class="[isUploading ? 'opacity-75' : '']" :disabled="isUploading">
            <span v-if="isUploading">Uploading...</span>
            <span v-else>
                {{ uploadedFile.file_url ? "Delete and replace file" : label }}
            </span>
        </label>
        <input
            :disabled="isUploading"
            v-show="false"
            :id="id"
            type="file"
            :name="name"
            :ref="name"
            @change="doHandleUpload"
            :accept="accept"
        />

        <ValidationProvider :rules="rules" v-slot="v" :vid="vid">
            <p v-if="v.errors.length" class="!opacity-100 subtext text-error">{{ v.errors[0] }}</p>
            <input type="hidden" v-show="false" v-model="uploadedFile.file_url" />
        </ValidationProvider>

        <div class="mt-3" v-if="error.message || error.errors.length">
            <AlertComponent
                message="The given file was invalid and failed to upload. Please ensure the file is no bigger than 8MB."
            />
        </div>
    </div>
</template>

<script>
import { ValidationProvider } from "vee-validate";

export default {
    name: "FileUploadComponent",
    props: {
        id: { type: String }, // Accepting an "id" property
        name: { type: String, default: "name" },
        label: { type: String, default: "" },
        apiEndpointUrl: { type: String, default: "" },
        fileData: {
            default: () => {
                return {
                    file_url: "",
                    file_type: "",
                };
            },
        },
        rules: { type: String, default: "required" }, // The validation rules set on the input. See VeeValidate for available rules
        vid: { type: String, default: "" }, // Used for VeeValidate
        accept: { type: String, default: "image/jpeg,image/png,application/pdf" },
    },
    components: {
        ValidationProvider,
    },
    computed: {
        isPdf() {
            return this.uploadedFile.file_type == "application/pdf";
        },
    },
    data: function () {
        return {
            isUploading: false,
            uploadProgress: 0, // Not currently utilised, but is here if we need it
            uploadedFile: this.fileData,
            error: {
                message: "",
                errors: [],
            },
            hasChangedUploadedFile: false,
        };
    },
    methods: {
        async doHandleUpload(event) {
            if (event.target.value) {
                let formData = new FormData();
                let file;
                if ((file = event.target.files[0])) {
                    formData.append("file", file, file.name);
                }

                if (this.apiEndpointUrl) {
                    let config = {
                        url: this.apiEndpointUrl,
                        method: "post",
                        data: formData,
                        onUploadProgress: (progressEvent) => {
                            this.uploadProgress = (progressEvent.loaded / progressEvent.total) * 100;
                        },
                    };

                    this.isUploading = true;
                    this.error.message = "";
                    this.error.errors = [];

                    await axios
                        .request(config)
                        .then(
                            (response) => {
                                this.uploadedFile = response.data;
                                this.isUploading = false;
                            },
                            (error) => {
                                console.log("error", error);
                                console.log(error.response.data);
                                this.isUploading = false;
                                this.error.message = error.response.data.message;
                                this.error.errors = error.response.data.errors.photo;
                            }
                        )
                        .finally(() => {
                            this.$refs[this.name].value = null; // Reset the value of the file upload input
                        });
                }
            }
        },
    },
    watch: {
        fileData(value) {
            this.uploadedFile = value;
        },
        uploadedFile(value) {
            this.errorMessage = "";
            this.uploadedFile = value;
            this.$emit("change");
        },
    },
};
</script>
